
import NewsletterSubscriptionForm from '@/components/shared/NewsletterSubscriptionForm'
import PinnableImage from '~/components/shared/PinnableImage.vue'
export default {
  components: { PinnableImage, NewsletterSubscriptionForm },
  props: {
    wppost: {
      type: Object,
      required: true,
    },
  },
  computed: {
    title() {
      return this.wppost.title.rendered
        ? this.wppost.title.rendered
        : this.wppost.title
    },
    cardImage() {
      const acfData = this.wppost.acf
      if (
        acfData &&
        Object.prototype.hasOwnProperty.call(acfData, 'pinterest_pin_image')
      ) {
        return acfData.pinterest_pin_image !== false
          ? acfData.pinterest_pin_image.replace(
              'https://api.plantssogood.com',
              'https://ik.imagekit.io/rajumandapati/psg'
            )
          : this.wppost.featured_image_src.replace(
              'https://api.plantssogood.com',
              'https://ik.imagekit.io/rajumandapati/psg'
            )
      }
      return this.wppost.featured_image_src.replace(
        'https://api.plantssogood.com',
        'https://ik.imagekit.io/rajumandapati/psg'
      )
    },
  },
}
